import type { TableColumnProps } from 'ant-design-vue'
import { reqRightsDisplay } from '~/api'
import { USER_LEVEL_KEY, type IEquity } from '~/api/interface'
import { fileSizeLimit } from '~/constants/subscribe'
import XTag from '~/components/xUserVerify/index.vue'
import { USER_VERIFY_STATUS } from '~/constants'

export const CertificationCompare = defineComponent({
  setup() {
    const { $t } = useNuxtApp()
    const userInfo = useUserInfo()
    const columns: TableColumnProps[] = [
      {
        title: $t('gong-neng'),
        dataIndex: 'name',
      },
      {
        title: $t('wei-ren-zheng'),
        dataIndex: 'unAuthorized',
      },
      {
        title: $t('yi-ren-zheng'),
        dataIndex: 'authorized',
      },
    ]

    const currentRightsType = userInfo.value?.rights_type

    const { data } = useAsyncData(() =>
      reqRightsDisplay({
        rights_type: [USER_LEVEL_KEY.UN_AUTHORIZED, currentRightsType].join(
          ','
        ),
      })
    )

    const getSingleFileSizeText = (rights?: IEquity) => {
      return (
        <div>
          <div>
            {$t('zi-ti')} {fileSizeLimit(rights?.font_limit || 0)}
          </div>
          <div>
            {$t('yin-pin')} {fileSizeLimit(rights?.audio_limit || 0)}
          </div>
          <div>
            {$t('tu-pian')} {fileSizeLimit(rights?.image_limit || 0)}
          </div>
          <div>
            {$t('shi-pin')} {fileSizeLimit(rights?.video_limit || 0)}
          </div>
          <div>PPT {fileSizeLimit(rights?.ppt_limit || 0)}</div>
          <div>PDF {fileSizeLimit(rights?.pdf_limit || 0)}</div>
        </div>
      )
    }

    const dataSource = computed(() => {
      const unAuthorized = data.value?.data?.rights.find(
        (item) => item.rights_type === USER_LEVEL_KEY.UN_AUTHORIZED
      )

      const authorized = data.value?.data?.rights.find(
        (item) => item.rights_type === currentRightsType
      )

      return [
        {
          name: $t('ren-zheng-biao-shi'),
          unAuthorized: (
            <XTag status={USER_VERIFY_STATUS.FAIL} class="!inline-block" />
          ),
          authorized: (
            <XTag status={USER_VERIFY_STATUS.SUCCESS} class="!inline-block" />
          ),
        },
        {
          name: $t('zuo-pin-shou-quan'),
          unAuthorized: $t('zuo-pin-yong-jiu-shou-quan'),
          authorized: $t('zuo-pin-yong-jiu-shou-quan'),
        },
        {
          name: $t('shou-quan-zhu-ti'),
          unAuthorized: $t('ge-ren'),
          authorized: authorized?.licensor_text || '-',
        },
        {
          name: $t('shou-quan-fan-wei'),
          unAuthorized: $t('xian-shang-yong-tu'),
          authorized: $t('xian-shang-xian-xia-quan-yong-tu'),
        },
        {
          name: $t('xin-mei-ti-ping-tai-ji-xian-shang-tui-guang'),
          unAuthorized: $t('shou-quan-ke-yong'),
          authorized: $t('shou-quan-ke-yong'),
        },
        {
          name: $t('wang-zhan-ying-yong-cheng-xu-wang-luo-shi-pin-yong-tu'),
          unAuthorized: $t('wu-shou-quan'),
          authorized: $t('shou-quan-ke-yong'),
        },
        {
          name: $t('hu-wai-guang-gao'),
          unAuthorized: $t('wu-shou-quan'),
          authorized: $t('shou-quan-ke-yong'),
        },
        {
          name: $t('wen-jian-shang-chuan-da-xiao'),
          unAuthorized: getSingleFileSizeText(unAuthorized),
          authorized: getSingleFileSizeText(authorized),
        },
      ]
    })

    return () => (
      <a-table
        columns={columns}
        dataSource={dataSource.value}
        pagination={false}
      ></a-table>
    )
  },
})
